import { IThemes } from './themes.model';
import { Injectable } from '@angular/core';
import { dispatch } from '@angular-redux/store';
import { AnyAction } from 'redux';

@Injectable()
export class ThemesActionService {

    static THEMES_LIST = 'THEMES_LIST';
    static DELETE_THEMES = 'DELETE_THEMES';
    static ADD_OR_UPDATE_THEMES = 'ADD_OR_UPDATE_THEMES';
    static MODIFY_THEMES = 'MODIFY_THEMES';
    static SET_THEMES_CURRENT = 'SET_THEMES_CURRENT';

    constructor() {

    }

    @dispatch()
    themesList = ( data ): AnyAction => ({ type: ThemesActionService.THEMES_LIST, payload: data })

    @dispatch()
    addOrUpdateThemes = ( data: IThemes ): AnyAction => ({ type: ThemesActionService.ADD_OR_UPDATE_THEMES, payload: data })

    @dispatch()
    deleteThemes = ( data ): AnyAction => ({ type: ThemesActionService.DELETE_THEMES, payload: data })

    @dispatch()
    modifyThemes = ( data ): AnyAction => ({ type: ThemesActionService.MODIFY_THEMES, payload: data })

    @dispatch()
    setThemesCurrent = ( data ): AnyAction => ({ type: ThemesActionService.SET_THEMES_CURRENT, payload: data })

}
